import { Typography as Text, TypographyProps as TextProps } from '@mui/material';

export default Text;
export type { TextProps };
